import React, { Component, Fragment } from 'react';
import { Form } from "formik";
import { Redirect } from "react-router";
import { Trans, withTranslation } from 'react-i18next';
import SecondHeader from "./Parts/SecondHeader";
import Header from "./Parts/Header";
import SubHeader from "./Parts/SubHeader";
import MSign from "./Sign/MSign";
import SmartId from "./Sign/SmartId";
import BankSign from "./Sign/Banksign";
import Loading from "./Parts/Loading";
import EmbeddedPdf from "./Parts/EmbeddedPdf";
import { CONSENT_SIGNING } from "../../constants";

//import AppContext from '../../contexts/AppContext';

class Consent extends Component {

    // static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            consents: {
                marketing_phone: false,
                marketing_mail: false,
                marketing_email: false,
                marketing_other: false,
                spouse: false
            },
            sub_step: 'consents',
            is_consents_expanded: false,
            // sub_step: 'chooseSignMethod',
            step_count: props.stepsNo,
            current_step: props.step,
            redirectToNextStep: false,
            loading: true,
            file_id: null,
            bankLinkUrls: [],
            isNextStepPossible: true,

            gtmConsentEventSent: false,
        };

        this.signButtonRef = React.createRef();
        this.state.pdf_url = this.generatePdfUrl();

        this.handleConsentChange = this.handleConsentChange.bind(this);
        this.chooseSignMethod = this.chooseSignMethod.bind(this);
        this.generatePdfUrl = this.generatePdfUrl.bind(this);
        this.callbackAfterSign = this.callbackAfterSign.bind(this);
        this.scrollToSignButton = this.scrollToSignButton.bind(this);
        this.markAllConsents = this.markAllConsents.bind(this);
        this.setTrackData = this.setTrackData.bind(this);
    }

    setTrackData() {
        this.setState({ trackData: {
                loan_amount: this.props.suggestion.amount,
                loan_period: this.props.suggestion.term,
                product_code: this.props.suggestion.application?.appl_product,
            } });
    }

    componentDidMount() {
        // const {setError} = this.context;

        if (this.props.client_type === 'S') {
            this.setState({loading: false});
            axios.get('/api/process/' + this.props.application_token + '/get_consents', { params: { client_type: this.props.client_type } })

        }

        if (this.props.client_type === 'P') {
            axios.get('/api/process/' + this.props.application_token + '/check_consent', { params: { client_type: this.props.client_type } })
                .then(
                    data => {
                        this.setState({loading: false});
                        if (data.data.data.has_consent) {
                                this.setState({ redirectToNextStep: true });
                        } else {
                            axios.get('/api/process/' + this.props.application_token + '/get_consents', { params: { client_type: this.props.client_type } })
                        }
                    },
                    error => {
                        this.setState({ loading: false, isNextStepPossible: false });
                    }
                )
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.suggestion.application.id !== undefined
            && this.props.suggestion.application.id !== null
            && !this.state.gtmConsentEventSent
        ) {

            this.setTrackData();

            gtm.sendEvent('base', {
                orderID: this.props.suggestion.application.id,
                event: 'checkoutunregistered3',
                products: this.state.trackData,
                actionField: { step: 3, action: 'consents' },
                pageTitle: 'Registration 3/4, consent to sign',
                eventId: 3867
            });
            this.setState({ gtmConsentEventSent: true });
        }
    }

    scrollToSignButton() {
        this.signButtonRef.current.scrollIntoView({ behavior: "smooth" });
    }

    generatePdfUrl() {
        let url = '/api/process/' + this.props.application_token + '/get_consent_pdf';

        let queryString = Object.keys(this.state.consents).map(key => key + '=' + this.state.consents[key]).join('&');

        url += '?' + queryString + '&client_type=' + this.props.client_type;

        return url;
    }

    callbackAfterSign() {

       //new version
        gtm.sendEvent('base', {
            event: 'loan_application_customer_data_sigining.completed',
            products: this.state.trackData,
        }, 2);

        this.setState({ redirectToNextStep: true });
    }

    chooseSignMethod() {
        if (this.state.isNextStepPossible === true) {
            this.setState({ isNextStepPossible: false });
        }

        gtm.sendEvent('base', {
            orderID: this.props.suggestion.application.id,
            event: 'checkoutunregistered4',
            products: this.state.trackData,
            actionField: { step: 4, action: 'signingConsent' },
            pageTitle: 'Registration 4/4, signing consent',
            eventId: 4423
        });

        //new version
        gtm.sendEvent('base', {
            event: 'loan_application_customer_data.saved',
            products: this.state.trackData,
        }, 2);

        axios.get(this.generatePdfUrl(), { params: { client_type: this.props.client_type } })
            .then(
                data => {
                    this.setState({
                        sub_step: 'chooseSignMethod',
                        current_step: parseInt(this.props.step) + 1,
                    });

                    this.props.scrollToProcessContainer();

                    let request_data = this.state.consents;
                    request_data.client_type = this.props.client_type;

                    axios.post('/api/process/' + this.props.application_token + '/get_consent_sign_info', request_data)
                        .then(
                            data => {
                                if (data.data.status === 'success') {
                                    this.setState({
                                        bankLinkUrls: data.data.data.links,
                                        file_id: data.data.data.file_id
                                    });
                                }
                            }
                        )
                },
                error => {
                    this.setState({ isNextStepPossible: true });
                }
            );
    }

    handleConsentChange(changeEvent) {
        let consents = this.state.consents;
        consents[changeEvent.target.getAttribute('data-consent-type')] = changeEvent.target.checked;
        this.setState(consents);

        let shouldGoToSignButton = Object.keys(consents).reduce((goToSignButton, current) => {
            if (current === 'spouse') {
                return goToSignButton;
            }
            return goToSignButton = goToSignButton && consents[current];
        }, true);

        if (shouldGoToSignButton) {
            this.scrollToSignButton();
        }

        this.setState({ pdf_url: this.generatePdfUrl() });
    }

    render() {
        if (this.state.redirectToNextStep) {
            return this.props.client_type == 'S'
                ? <Redirect push={true} to={'/' + this.props.application_token + '/process/waiting_consent?client_type=S'} />
                : <Redirect push={true} to={this.props.suggestion.process_step_urls.choose_terms} />
        }

        return (
            <div>
                <Header title={this.props.t('step.registration')} />

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={this.props.t('substep.' + this.state.sub_step)}
                                   step_count={this.state.step_count}
                                   current_step={this.state.current_step} />
                        <div className="row">

                            {this.props.client_type === 'P' &&
                                <SecondHeader suggestion={this.props.suggestion} />
                            }

                            {this.state.loading ?
                                <div className="tab-content frame p-4 p-sm-5 w-100" id="authTabContent">
                                    <div aria-labelledby="private-tab" className="tab-pane fade show active"
                                         id="private" role="tabpanel">
                                        <Loading/>
                                    </div>
                                </div>
                                :
                                <Fragment>
                                    {this.state.sub_step === 'consents' ?
                                        <Fragment>
                                            <Form className="form form-layout mt-5 pb-2">
                                                <div className="container form-layout__2-col">
                                                    <div className="col-12 mb-4">
                                                        <p>{this.props.t('forms.consent_text')}</p>
                                                    </div>

                                                    <div className="col-12 col-lg-6 col-md-6 mb-3 mb-md-0">
                                                        {this.props.t('forms.i_agree_to_get')}
                                                    </div>
                                                    <div className="col-12 col-lg-6 col-md-6">
                                                        <div className="form-group col-12">
                                                            <div className="custom-control custom-checkbox">
                                                                <div className="btn btn-primary"
                                                                     onClick={this.markAllConsents}
                                                                >
                                                                    {this.props.t('forms.agree')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.is_consents_expanded ?
                                                            <Fragment>
                                                                <div className="form-group col-12">
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox"
                                                                               id="marketing_phone"
                                                                               name="marketing_phone"
                                                                               className="custom-control-input"
                                                                               data-consent-type="marketing_phone"
                                                                               checked={this.state.consents.marketing_phone}
                                                                               onChange={this.handleConsentChange}
                                                                        />
                                                                        <label className="custom-control-label"
                                                                               htmlFor="marketing_phone">{this.props.t('forms.by_phone')}</label>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group col-12">
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox"
                                                                               id="marketing_mail"
                                                                               name="marketing_mail"
                                                                               className="custom-control-input"
                                                                               data-consent-type="marketing_mail"
                                                                               checked={this.state.consents.marketing_mail}
                                                                               onChange={this.handleConsentChange}
                                                                        />
                                                                        <label className="custom-control-label"
                                                                               htmlFor="marketing_mail">{this.props.t('forms.by_snail_mail')}</label>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group col-12">
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox"
                                                                               id="marketing_email"
                                                                               name="marketing_email"
                                                                               className="custom-control-input"
                                                                               data-consent-type="marketing_email"
                                                                               checked={this.state.consents.marketing_email}
                                                                               onChange={this.handleConsentChange}
                                                                        />
                                                                        <label className="custom-control-label"
                                                                               htmlFor="marketing_email">{this.props.t('forms.by_email')}</label>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group col-12">
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="checkbox"
                                                                               id="marketing_other"
                                                                               name="marketing_other"
                                                                               className="custom-control-input"
                                                                               data-consent-type="marketing_other"
                                                                               checked={this.state.consents.marketing_other}
                                                                               onChange={this.handleConsentChange}
                                                                        />
                                                                        <label className="custom-control-label"
                                                                               htmlFor="marketing_other">{this.props.t('forms.by_social_media')}</label>
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                            : ''}

                                                    </div>
                                                </div>
                                            </Form>

                                            <div className="col-12 mt-4">
                                                <div className="embed-document">
                                                    <EmbeddedPdf src={this.state.pdf_url} />
                                                </div>
                                            </div>

                                            <div className="form-group col-12 mt-4">
                                                <div className="custom-control custom-checkbox mt-3">
                                                    <input type="checkbox"
                                                           className="custom-control-input"
                                                           id="spouse"
                                                           name="spouse"
                                                           data-consent-type="spouse"
                                                           checked={this.state.consents.spouse}
                                                           onChange={this.handleConsentChange}
                                                    />
                                                    <label className="custom-control-label"
                                                           htmlFor="spouse">{this.props.t('forms.spouse_consent')}</label>
                                                </div>
                                            </div>


                                            <div
                                                className="form-group col-12 d-flex flex-column align-items-center mt-3"
                                                ref={this.signButtonRef}
                                            >
                                                <button className="btn btn-primary btn-lg"
                                                        onClick={this.chooseSignMethod}
                                                        id="btn-show-consent-sign-options"
                                                        disabled={!this.state.isNextStepPossible}
                                                >{this.props.t('forms.sign_consent')}</button>
                                            </div>


                                        </Fragment> : ''}

                                    {this.state.sub_step === 'chooseSignMethod' ?
                                        <Fragment>
                                            <div className="tab-content frame p-4 p-sm-5 w-100" id="authTabContent">
                                                <div aria-labelledby="private-tab" className="tab-pane fade show active"
                                                     id="private" role="tabpanel">
                                                    <ul className="nav nav-tabs bg-gray-cloud justify-content-center"
                                                        id="authDeviceTab" role="tablist">
                                                        <li className="nav-item">
                                                            <a aria-controls="auth-id-bank" aria-selected="true"
                                                               className="nav-link"
                                                               data-toggle="tab" href="#auth-id-bank"
                                                               id="auth-id-bank-tab"
                                                               role="tab">
                                                                <i className="icons icon-building"></i> {this.props.t('forms.sign_by_1_ct')}
                                                            </a>
                                                        </li>
                                                        {this.state.file_id &&
                                                        <li className="nav-item">
                                                            <a aria-controls="auth-mobile-id" aria-selected="false"
                                                               className="nav-link"
                                                               data-toggle="tab" href="#auth-mobile-id"
                                                               id="auth-mobile-id-tab" role="tab">
                                                                <i className="icons icon-phone"></i> {this.props.t('forms.sign_by_esign')}
                                                            </a>
                                                        </li>
                                                        }

                                                        {this.state.file_id &&
                                                        <li className="nav-item">
                                                            <a aria-controls="auth-smart-id" aria-selected="false"
                                                               className="nav-link active"
                                                               data-toggle="tab" href="#auth-smart-id"
                                                               id="auth-smart-id-tab" role="tab">
                                                                <i className="icon-smartid"></i> {this.props.t('forms.sign_by_smart_id')}
                                                            </a>
                                                        </li>
                                                        }
                                                    </ul>
                                                    <div className="tab-content border py-3" id="authDeviceTabContent">
                                                        <div aria-labelledby="auth-id-bank-tab"
                                                             className="tab-pane fade" id="auth-id-bank"
                                                             role="tabpanel">
                                                            <div className="container py-4">
                                                                <div
                                                                    className="row bank-links d-flex justify-content-center">
                                                                    <div className="col-12 col-md-8">
                                                                        <div className="container">
                                                                            <BankSign
                                                                                bankLinkUrls={this.state.bankLinkUrls}
                                                                                applicationId={this.props.suggestion.application.id}
                                                                                consentProcess={true}
                                                                                trackData={this.state.trackData}
                                                                            />
                                                                        </div>
                                                                        <div className="container mt-3">
                                                                            <div className="row">
                                                                                <div className="col-12 text-center">
                                                                                    <Trans
                                                                                        i18nKey="forms.have_questions">
                                                                                        Turite klausimų? Skambinkite
                                                                                        mums <a href="tel:+37070070080">+370
                                                                                        700 700 80</a> ir mes Jums
                                                                                        padėsime atlikti dokumento
                                                                                        pasirašymą
                                                                                    </Trans>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {this.state.file_id &&
                                                        <div aria-labelledby="auth-mobile-id"
                                                             className="tab-pane fade"
                                                             id="auth-mobile-id"
                                                             role="tabpanel">
                                                            <div className="container py-5 p-lg-5">
                                                                <div className="row justify-content-md-center">
                                                                    <MSign
                                                                        file_id={this.state.file_id}
                                                                        application_token={this.props.application_token}
                                                                        phone={this.props.phone}
                                                                        callback={this.callbackAfterSign}
                                                                        client_type={this.props.client_type}
                                                                        trackData={this.state.trackData}
                                                                        step={CONSENT_SIGNING}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        }

                                                        {this.state.file_id &&
                                                        <div aria-labelledby="auth-smart-id"
                                                             className="tab-pane fade active show"
                                                             id="auth-smart-id"
                                                             role="tabpanel">
                                                            <div className="container py-5 p-lg-5">
                                                                <div className="row justify-content-md-center">
                                                                    <SmartId
                                                                        file_id={this.state.file_id}
                                                                        application_token={this.props.application_token}
                                                                        callback={this.callbackAfterSign}
                                                                        client_type={this.props.client_type}
                                                                        trackData={this.state.trackData}
                                                                        step={CONSENT_SIGNING}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment>
                                        : ''}
                                </Fragment>
                            }
                        </div>

                    </div>
                </div>
            </div>
        )
    }

    markAllConsents() {
        let consents = this.state.consents;

        Object.keys(consents).forEach((key) => {
            if (key !== 'spouse') {
                consents[key] = true;
            }

        });

        this.setState({
            consents: consents,
            is_consents_expanded: true,
        });
        this.setState({ pdf_url: this.generatePdfUrl() });
        this.scrollToSignButton();
    }
}

// export default Embe;
export default withTranslation()(Consent);
